<template>
  <div class="row m-0 bg-custom-bg-color p-3 align-items-center">
    <div class="col-sm-6 col-12">
      <div class="h5 m-0 text-custom-text">{{title}}</div>
      <div class="text-custom-gray-2"> {{ create_data }}</div>
    </div>

    <div class="col-sm-6 col-12 text-sm-right">
      <div class="row-grid">
        <span class="text-custom-text">{{ before_text }}</span>
        <span v-if="!isEmpty(after_text)" class="ml-2"/>
        <i v-if="!isEmpty(after_text)" class="fa fa-long-arrow-right" aria-hidden="true"></i>
        <span v-if="!isEmpty(after_text)" class="ml-2"/>
        <span v-if="!isEmpty(after_text)" class="text-custom-text">{{ after_text }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import {isEmpty} from "@/util/helpers";


export default {
  name: "HistoryItem",
  props: {
    title: {
      type: String,
      default: ''
    },
    create_data: {
      type: String,
      default: ''
    },
    before_text: {
      type: String,
      default: ''
    },
    after_text: {
      type: String,
      default: ''
    },
  },
  data() {
    return {};
  },
  methods: {
    isEmpty(val){
      return isEmpty(val);
    }
  }
}
</script>

<style scoped>

</style>
